import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, Carousel } from '../../../../components/ui';
import ProfessionalCard from '../../../../components/ProfessionalCard';
import styles from './ProfessionalsHighlight.module.css';

export default function ProfessionalsHighlight({ profissionais = [] }) {
  const { t } = useTranslation('home');

  if (!profissionais || profissionais.length === 0) return null;

  return (
    <section className={styles.root}>
      <Carousel
        className={styles.carousel}
        header={<h2 className={styles.title}>{t('RELEVANT_PROFESSIONALS')}</h2>}
        slidesToShow={{ base: 4, xl: 3, lg: 2, sm: 1 }}
        gap={16}
        dots={false}
        prevLabel={t('PROFESSIONALS_PREV')}
        nextLabel={t('PROFESSIONALS_NEXT')}>
        {profissionais.map(p => (
          <div key={p.id} className={styles.slide}>
            <ProfessionalCard item={p} />
          </div>
        ))}
      </Carousel>
      <div className={styles.cta}>
        <Button variant='primary' as={Link} to='/catalogo?tipo=consultoria'>
          {t('SEE_THE_CONSULTANCIES')}
        </Button>
      </div>
    </section>
  );
}

ProfessionalsHighlight.propTypes = {
  profissionais: PropTypes.array
};
